import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CARD_SHADOW, COLORS } from '../IndividualPlan/tokens';
import { PAGE_MAX_WIDTH } from '../../theme';

export const ContentColumn = styled(Box)({
  maxWidth: PAGE_MAX_WIDTH + 48,
  margin: '0 auto',
  paddingLeft: 24,
  paddingRight: 24,
});

export const DistrictHeader = styled(Box)({
  marginBottom: 8,
});

export const ToggleBar = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 24,
  marginBottom: 8,
});

export const SectionSlot = styled('section')({
  marginTop: 20,
  padding: 24,
  backgroundColor: '#FFFFFF',
  borderRadius: 12,
  boxShadow: CARD_SHADOW,
});

export const ChartPanel = styled(Box)({
  backgroundColor: COLORS.bg,
  borderRadius: 8,
  padding: 16,
});

export const SectionEyebrow = styled('p')({
  margin: 0,
  marginBottom: 4,
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 1,
  textTransform: 'uppercase',
  color: COLORS.muted,
});

export const SectionHeading = styled('h2')({
  margin: 0,
  marginBottom: 16,
  fontSize: 20,
  fontWeight: 700,
  color: COLORS.ink,
});

export const SubsectionCard = styled('section')({
  marginTop: 16,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: '16px 20px 24px',
  border: `1px solid ${COLORS.divider}`,
  borderRadius: 8,
  '& .program-performance-subheading': {
    margin: 0,
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 600,
    color: COLORS.ink,
  },
  '& .program-performance-subnumber': {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 500,
    color: COLORS.muted,
  },
});

export const SubsectionHeader = styled('div')({
  display: 'flex',
  alignItems: 'baseline',
  gap: 8,
});
